import { Button } from "antd";
import clsx from "clsx";
import { useState } from "react";
import { AiFillStar } from "react-icons/ai";

import s from "./StarGroup.module.css";

const STARS = [1, 2, 3, 4, 5] as const;

interface StarGroupProps {
  value: number;
  onChange: (value: number) => void;
  label: string;
  disabled?: boolean;
}

export const StarGroup = ({
  value,
  onChange,
  label,
  disabled = false,
}: StarGroupProps) => {
  const [hover, setHover] = useState<number | null>(null);
  const active = hover ?? value;

  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={s.group}
      tabIndex={-1}
      onMouseLeave={() => setHover(null)}
    >
      {STARS.map(star => {
        const isSelected = value === star;
        const isFocusable = isSelected || (value === 0 && star === 1);
        return (
          <Button
            key={star}
            type="text"
            role="radio"
            aria-checked={isSelected}
            aria-label={`${star} out of ${STARS.length} stars`}
            disabled={disabled}
            tabIndex={isFocusable ? 0 : -1}
            data-testid={`feedback-star-${star}`}
            className={clsx(s.star, star <= active && s.starOn)}
            onClick={() => onChange(star)}
            onMouseEnter={() => setHover(star)}
            icon={<AiFillStar aria-hidden="true" className={s.icon} />}
          />
        );
      })}
    </div>
  );
};
